import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getSignedIdStatus, getPageLayoutType, getCurrentTime } from "../../../common/utils/utilsFunc"
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const DebtAndEndowmentContext = createContext();
export const ACTIONS = {
    SET_LOAD_PAGE: "SET_LOAD_PAGE",  
    SET_IDCLIENT:"SET_IDCLIENT",
    SET_IDCLIENT_AUX:"SET_IDCLIENT_AUX",
    SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
    SET_IDLIST: "SET_IDLIST",
    SET_JSON_BUTTON:"SET_JSON_BUTTON",
    SET_RESPONSE_WEB_CONTENT: "SET_RESPONSE_WEB_CONTENT",
    SET_CONFIRM: "SET_CONFIRM",
    SET_PDF: "SET_PDF",
    SET_ERROR:"SET_ERROR",
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};

const initialState = {
    idList: [],
    loadPage: false,
    idClient: null,
    idClientAux: null,
    detailClient: null,
    jsonButton: null,
    pagoCertificateWebContent: null,
    confirm: false,
    pdfCertificate: null,
    errorCatch: null,
    webContentTextInfo: "",

};
const DebtAndEndowmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_IDLIST: {
          return {
            ...state,
            idList: action.payload,
          };
        }
        case ACTIONS.SET_LOAD_PAGE: {
          return {
            ...state,
            loadPage: action.payload,
          };
        }
        case ACTIONS.SET_IDCLIENT: {
          return {
            ...state,
            idClient: action.payload,
          };
        }
        case ACTIONS.SET_IDCLIENT_AUX: {
          return {
            ...state,
            idClientAux: action.payload,
          };
        }
        case ACTIONS.SET_DETAIL_CLIENT: {
          return {
            ...state,
            detailClient: action.payload,
          };
        }
        case ACTIONS.SET_JSON_BUTTON: {
          return {
            ...state,
            jsonButton: action.payload,
          };
        }
        case ACTIONS.SET_RESPONSE_WEB_CONTENT: {
          return {
            ...state,
            pagoCertificateWebContent: action.payload,
          };
        }
        case ACTIONS.SET_CONFIRM: {
          return {
            ...state,
            confirm: action.payload,
          };
        }
        case ACTIONS.SET_PDF: {
          return {
            ...state,
            pdfCertificate: action.payload,
          };
        }
        case ACTIONS.SET_ERROR: {
          return {
            ...state,
            errorCatch: action.payload,
          };
        }
        case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
          return {
            ...state,
            webContentTextInfo: action.payload,
          };
        }
        default: {
            return state;
        }
    }
};
const DebtAndEndowmentContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(DebtAndEndowmentReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);

  React.useEffect(() => {
      if(state.idClient){
        dispatch({
          payload: state.idClient,
          type: ACTIONS.SET_IDCLIENT_AUX,
        });
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.idClient, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_DETAIL_CLIENT,
          });
          dispatch({
            payload: "",
            type: ACTIONS.SET_IDCLIENT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
      }
  },[state.idClient])

  React.useEffect(() => {

    if(accessToken){
      LiferayService.getIdList(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: response,
          type: ACTIONS.SET_IDLIST,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      })
    }
  },[accessToken])

  React.useEffect(() => {
    if (state.loadPage) {
    if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
    }
  }, [state.loadPage]);

  React.useEffect(() => {
    if(state.jsonButton?.handleButton){
      let typeCertificate = state.jsonButton?.typeCertificate === "DO" ? "Crear: Certificado Dotación" : "Crear: Certificado Deuda"
      LiferayService.verificarPagoCertificado(properties.base_url_api, properties.codigo_empresa, typeCertificate)
      .then((response) => {
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        if(response.hasPayment){
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_WEB_CONTENT,
          });
          
        }

        if(!response.hasPayment){
          let webContentCorreoTitle = state.jsonButton.typeCertificate === "DO" ? properties.web_content_certificate_dotacion : properties.web_content_certificate_deuda
          LiferayService.emisionCertificado(properties.base_url_api, state.idClient ? state.idClient : state.idClientAux, properties.codigo_empresa, properties.url_ws_empresa, state.jsonButton.typeCertificate, state.jsonButton.canal, state.jsonButton.email, webContentCorreoTitle, getSignedIdStatus())
          .then((response) => {
            if(response.status){
              dispatch({
                payload: response,
                type: ACTIONS.SET_PDF,
              })
            } else {

              response.data.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.download = `Certificado_${getCurrentTime()}.pdf`;
                link.href = fileURL;
                link.click();

                dispatch({
                  payload: fileURL,
                  type: ACTIONS.SET_PDF,
                })
              });

            }
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR,
            });

            dispatch({
              payload: null,
              type: ACTIONS.SET_JSON_BUTTON,
            });
          })
          .catch((error) => {
            dispatch({
              payload: error,
              type: ACTIONS.SET_ERROR,
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_JSON_BUTTON,
            });
          })
        }
      })
    }
  }, [state.jsonButton])

  React.useEffect(() => {
    if(state.confirm){
      let webContentCorreoTitle = state.jsonButton.typeCertificate === "DO" ?  properties.web_content_certificate_dotacion : properties.web_content_certificate_deuda
      LiferayService.emisionCertificado(properties.base_url_api, state.idClient ? state.idClient : state.idClientAux, properties.codigo_empresa, properties.url_ws_empresa, state.jsonButton.typeCertificate, state.jsonButton.canal, state.jsonButton.email, webContentCorreoTitle, getSignedIdStatus())
      .then((response) => {
        if(response.status){
          dispatch({
            payload: response,
            type: ACTIONS.SET_PDF,
          })
        } else {

          response.data.blob().then(blob => {
            const fileURL = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.download = `Certificado_${getCurrentTime()}.pdf`;
            link.href = fileURL;
            link.click();

            dispatch({
              payload: fileURL,
              type: ACTIONS.SET_PDF,
            })
          });
          
        }
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: false,
          type: ACTIONS.SET_CONFIRM,
        })
        dispatch({
          payload: null,
          type: ACTIONS.SET_JSON_BUTTON,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_JSON_BUTTON,
        });
      })
    }
  }, [state.confirm])

  return (
    <DebtAndEndowmentContext.Provider value={[state, dispatch]}>
      {children}
    </DebtAndEndowmentContext.Provider>
  );
};
export default DebtAndEndowmentContextProvider;